<template>
  <div class="has-logo">
    <logo :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :collapse="isCollapse"
        background-color="#232221"
        text-color="#6e7e8e"
        active-text-color="#e8e8e8"
        :collapse-transition="false"
        mode="vertical"
        :default-active="defaultActive"
        @select="handleSelect"
      >
      <template v-for="(item, index) in menuData">
        <template v-if="item.auth !== false">
          <el-submenu
            :index="`${item.key}$${index}`"
            v-if="item.children"
            :key="`${item.key}_${index}`"
          >
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.name }}</span>
            </template>
            <!-- 此处调用自身实现递归 -->
            <children-menu :children="item.children"></children-menu>
          </el-submenu>
          <el-menu-item :index="item.key" :key="item.key" v-else>
            <i :class="item.icon"></i>
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </template>
      </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import ChildrenMenu from "./ChildrenMenu.vue";
import MenuHelper from "../helper";

export default {
  name: "SideBar",
  props: {
    menuData: {
      type: Array
    },
  },
  data() {
    return {
      defaultActive: '',
      cloneMenu: [],
    }
  },
  components: { Logo, ChildrenMenu },
  computed: {
    ...mapGetters([ "sidebar"]),
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  watch: {
    // 根据 menuData 的变化拿到默认的 defaultActive
    menuData(val) {
      if (val) {
        this.initBreadArr();
      }
    },
    "$route.path"() {
      const temp = this.$route ? this.$route.path : false;
      const fullPath = MenuHelper.getFullPath(temp);
      this.initBreadArr(fullPath);
      // this.defaultActive = this.getActiveItem(fullPath);
      this.defaultActive = temp.substring(1);
    }
  },
  methods: {
    getActiveItem (fullPath) {
      for (let i = fullPath.length - 1; i >= 0; i--) {
        if (fullPath[i]) {
          const result = MenuHelper.searchKey(fullPath[i], this.menuData);
          if (result) {
            return fullPath[i];
          }
        }
      }
      return "";
    },
    handleSelect(index, indexPath) {
      const newIndexPath = indexPath.map((item) => {
        return item.indexOf('$') !== -1 ? item.split('$')[0] : item;
      });
      const { href, hashMenu } = MenuHelper.makeUrl(newIndexPath, this.menuData);
      this.setTitleName(index, this.menuData);
      this.updateBreadArr(href.split('/'), hashMenu);
      window.history.pushState({}, "", href);
    },
    //设置标题头
    setTitleName(indexPath, menuData) {
      const curMenuData = MenuHelper.hashMenu(menuData);
      //兼容菜单无key时；
      this.menuName = curMenuData[indexPath]?.name || '商管平台';
      document.title = this.menuName;
    },
    getActiveItemKey() {
      if(window.location.hash) {
        const { pathname, hash } = window.location;
        const pathArr = pathname.split('/');
        const hashArr = hash.split('/');
        const activeOpenKeyArr = [pathArr[pathArr.length - 1]];
        if(hashArr.length > 2) {
          this.defaultActive = hashArr.pop();
          hashArr.shift();
        } else {
          if(hashArr[1]) {
            this.defaultActive = hashArr[1];
          } else {
            this.defaultActive = pathArr[pathArr.length - 1];
          }
        }
        return activeOpenKeyArr
      } 
    },
    updateBreadArr(pathArr, hashMenu) {
      const arr = [];
      if (pathArr.length) {
        pathArr.forEach(p => {
          if (p.indexOf('?') > -1) {
            arr.push(p.split('?')[0]);
          } else if (p.indexOf('#') > -1) {
            arr.push(p.split('#')[0]);
          } else {
            arr.push(p);
          }
        });
      }
      let pathArrUse = arr.filter(item => item !== '').slice(1);
      pathArrUse = pathArrUse.map(item => {
        return hashMenu[item.replace('#','')]
      });
      this.$store.dispatch("app/updateBreadArr", pathArrUse);
    },
    initBreadArr(pathArr) {
      if(window.location.hash) {
        const hashMenu = MenuHelper.hashMenu(this.menuData);
        if(pathArr) {
          this.updateBreadArr(pathArr, hashMenu);
        } else {
          const { pathname, hash } = window.location;
          const href = pathname + hash;
          this.updateBreadArr(href.split('/'), hashMenu);
        }
      }
    }
  },
  mounted() {
    // this.getActiveItemKey();
    const route = this.$route.path;
    this.defaultActive = route.substring(1);
    this.initBreadArr();
  }
};
</script>

<style lang="scss" scoped>
</style>
